import { ReduxActions } from './constants';

/**
 * Storage of all registered TextToSpeech components. roboTextStorage
 * should always contain all roboTextSpeech components on the screen at any
 * given time.
 */
const initialState = {
  roboTextStorage: [],
  /**
   * Shape of objects in roboTextStorage:
   * {
   *  id: 0,
   *  gameId: 'game_id',
   *  voiceDataId: 'defaultRobovoiceId',
   *  startAudioTime: 0,
   *  endAudioTime: 0,
   *  audioDuration: 0,
   *  textContent: 'text displayed on the screen',
   *  timeline: {
   *    events: [],
   *    playInterval: setInterval
   *  }
   * }
   */
};

const robovoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * Initialzes TextToSpeech component to the Redux store.
     * @param {object} payload {
     *  id: number, // Unique TextToSpeech id
     * }
     */
    case ReduxActions.INIT_ROBOTEXT: {
      const roboTextStorage = [...state.roboTextStorage];
      const index = roboTextStorage.findIndex(robo => robo.id === action.payload.id);
      if (index >= 0) {
        roboTextStorage[index] = { id: action.payload.id };
      } else {
        roboTextStorage.push({ id: action.payload.id });
      }
      return {
        ...state,
        roboTextStorage,
      };
    }

    /**
     * Unregister and remove a TextToSpeech component from the Redux store.
     * @param {object} payload { id: number }  // id of the TextToSpeech component to remove from the store
     */
    case ReduxActions.UNREGISTER_ROBOTEXT: {
      const { id } = action.payload;
      const roboTextStorage = state.roboTextStorage.filter(robo => robo.id !== id);

      return {
        ...state,
        roboTextStorage,
      };
    }

    /**
     * Register a timeline object with an already registered TextToSpeech component.
     * @param {object} payload { id: number, timeline: object }
     */
    case ReduxActions.REGISTER_ROBOTEXT: {
      const newRoboText = {
        id: action.payload.id,
        gameId: action.payload.gameId,
        voiceDataId: action.payload.voiceDataId,
        startAudioTime: action.payload.startAudioTime,
        endAudioTime: action.payload.endAudioTime,
        audioDuration: action.payload.audioDuration,
        textContent: action.payload.textContent,
        timeline: action.payload.timeline,
      };

      const roboTextStorage = [...state.roboTextStorage];
      const index = roboTextStorage.findIndex(robo => robo.id === action.payload.id);
      if (index >= 0) {
        roboTextStorage[index] = newRoboText;
      } else {
        roboTextStorage.push(newRoboText);
      }
      roboTextStorage.sort((a, b) => a.id - b.id);
      return {
        ...state,
        roboTextStorage,
      };
    }

    default:
      return state;
  }
};

export default robovoiceReducer;
